export default {
    list: {
        title: 'Users',
        empty: 'No users',
        cols: {
            name: 'Name',
            username: 'Username',
            email: 'Email',
            active: 'Active',
            admin: 'Admin'
        },
        fullNameFallback: '(no name)'
    },
    filter: {
        search: 'Search (name, username, or email)',
        active: 'Active',
        activeOptions: {
            all: 'All',
            active: 'Active',
            inactive: 'Inactive'
        }
    },
    form: {
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        validUntil: 'Valid until',
        isActive: 'Active',
        isSuperuser: 'Administrator',
        section: {
            edit: 'Edit',
            rights: 'Rights',
            metadata: 'Metadata'
        }
    },
    metadata: {
        username: 'Username',
        dateJoined: 'Date joined',
        lastLogin: 'Last login',
        lastLoginNever: 'Never',
        isStaff: 'isStaff',
        yes: 'Yes',
        no: 'No'
    },
    rights: {
        cols: {
            instance: 'Instance',
            bzucoAdmin: 'Bzuco admin',
            manageUsers: 'Users',
            manageEvents: 'Events',
            manageTicketsets: 'Sets',
            manageTickets: 'Tickets',
            manageDevices: 'Devices',
            stats: 'Stats',
            primary: 'Primary'
        },
        empty: 'User has no instances',
        savePerRow: 'Save',
        dirtyIndicator: 'unsaved changes'
    },
    bzucoSynced: {
        primaryTooltip: 'Primary instance — determined by login mutation, not editable'
    },
    confirm: {
        deleteTitle: 'Delete user?',
        deleteBody: 'Really delete user "{name}"?',
        deletePermissionTooltip: 'Only superuser can delete users',
        unsavedChanges: 'You have unsaved changes. Close anyway?'
    },
    toast: {
        profileSaved: 'Profile saved',
        rightsSaved: 'Rights saved',
        deleted: 'User deleted'
    }
}
